import React, { useEffect } from "react";
import { element } from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "slices/user";
import { IDLE_TIME_OUT, ROUTES } from "utils/constants";
import { useNavigate } from "react-router-dom";
import { getWalletBalance } from "slices/payment";
import IdleTimeOutHandler from "components/app-idle-timeout/IdleTimeOutHandler";

const AppLayout = ({ children }) => {
  const { userToken } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isActive, setIsActive] = React.useState(true);

  const userLogout = () => {
    dispatch(logout({ mode: "manual" }));
  };

  useEffect(() => {
    dispatch(getWalletBalance());
  }, []);

  useEffect(() => {
    if (userToken === "") {
      navigate("/" + ROUTES.LOGIN);
    }
  }, [userToken]);

  return (
    <>
      <IdleTimeOutHandler
        timeOutInterval={IDLE_TIME_OUT}
        onActive={() => {
          setIsActive(true);
        }}
        onIdle={() => {
          setIsActive(false);
        }}
        onLogout={() => {
          userLogout();
        }}
      />

      <main>{children}</main>

    </>
  );
};

AppLayout.propTypes = {
  children: element,
};

export default AppLayout;
